import { useRuns } from '@/hooks/use-runs'
import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Link } from 'react-router'
import { format } from 'date-fns'
import type { BadgeProps } from '@/components/ui/badge'

function getStatusVariant(
  status: string
): BadgeProps['variant'] {
  switch (status) {
    case 'completed':
      return 'success'
    case 'failed':
      return 'destructive'
    case 'processing':
      return 'warning'
    default:
      return 'secondary'
  }
}

export function RecentRuns() {
  const { data: runs, isLoading } = useRuns({ pageSize: 10 })

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Recent Runs</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-32 text-muted-foreground">
            Loading...
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Runs</CardTitle>
      </CardHeader>
      <CardContent>
        {runs && runs.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>File</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Workflow</TableHead>
                <TableHead>Created</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {runs.slice(0, 10).map((run) => (
                <TableRow
                  key={run.fileId}
                  className="cursor-pointer hover:bg-muted/50"
                >
                  <TableCell>
                    <Link
                      to={`/runs/${run.fileId}`}
                      className="font-medium hover:underline"
                    >
                      {run.fileName || run.originalName || run.fileId}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Badge variant={getStatusVariant(run.status)}>
                      {run.status}
                    </Badge>
                  </TableCell>
                  <TableCell className="capitalize">{run.workflow}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {format(new Date(run.createdAt), 'MMM dd, HH:mm')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="flex items-center justify-center h-32 text-muted-foreground">
            No recent runs
          </div>
        )}
      </CardContent>
    </Card>
  )
}
